@import 'styles/mixins';
@import 'styles/variables';

.th {
  @include sm-regular;
  @include line-clamp;
  color: $grey-40;
  background: var(--neutral-0);
  padding-left: 14px;
  padding-right: 10px;
  height: 24px;
  border-right: 1px solid $grey-5;
  transition: color 250ms ease-in-out;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: $grey-90;
  }
}
